export default {

    functional: true,

    props:
    {
        label:
        {
            type: String,
        },

        onClick:
        {
            type: Function,
        },
    },

    render(h, { data, props })
    {
        return h(
            'div',

            {
                staticClass: data.staticClass,

                class: [
                    'vh-chips',
                ],
            },

            [
                h(
                    'label',

                    props.label,
                ),
                
                h(
                    'a',
                    {
                        class: [
                            'vh-link-reset',
                            'vh-point',
                        ],

                        on:
                        {
                            click: props.onClick,
                        },
                    },

                    [
                        h(
                            'i',

                            {
                                class: [
                                    'vh-chips-close',
                                    'fa fa-times',
                                ],
                            },
                        ),
                    ],
                ),
            ],

        );
    },
};



// WEBPACK FOOTER //
// ./src/components/chips/vh-chips.js